import { render } from "./accountMgr.vue?vue&type=template&id=64103463&scoped=true"
import script from "./accountMgr.vue?vue&type=script&lang=js"
export * from "./accountMgr.vue?vue&type=script&lang=js"

import "./accountMgr.vue?vue&type=style&index=0&id=64103463&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64103463"]])

export default __exports__